/**
 * @licence
 * Copyright 2021 ModBros OG
 * Licenced under apache Licence, Version 2.0
 */

/**
 * Do not edit directly!
 * Generated on Wed Oct 13 2021 19:02:58 GMT+0200 (Central European Summer Time)
 */

export const Width = {
  None: 'var(--modbros-width-none, 0)',
  Default: 'var(--modbros-width-default, 1px)'
};
export const Radius = {
  None: 'var(--modbros-radius-none, 0)',
  Minimal: 'var(--modbros-radius-minimal, 3px)',
  Default: 'var(--modbros-radius-default, 8px)',
  Full: 'var(--modbros-radius-full, 100%)'
};
export default {
  Width,
  Radius,
}